import React from 'react';
import PropTypes from 'prop-types';
import EntryDoorMeasures from './components/measures/EntryDoorMeasures.jsx';
import DoorCharts from './components/charts/DoorCharts.jsx';
import configuration from './assets/entry_configuration.png';
import handing from './assets/entry_handing.png';
import ArchesTransoms from './components/ArchesTransoms.jsx';
import LaborMaterial from './components/LaborMaterial.jsx';
import Comments from './components/Comments.jsx';
import ProjectNeeds from './components/ProjectNeeds.jsx';
import HomeDiagram from './components/HomeDiagram';
import ProductTemplate from './components/ProductTemplate';

function EntryDoorTemplate({
  data,
  onChange,
  permitRequired,
  onPermitRequiredChange,
  onReadStart,
  onReadEnd,
}) {
  const {
    measures = { entry_doors: [] },
    arches_transoms_measures = [],
    labors_materials = [],
    comments = '',
    needs = {},
    home_diagram = {},
    product_template = {},
  } = data;

  return (
    <div>
      <h4>Entry Door Worksheet</h4>
      <DoorCharts
        configurationChart={configuration}
        handingChart={handing}
        configAlt="Entry Door Configuration Chart"
        handingAlt="Entry Door Handing Chart"
      />
      <EntryDoorMeasures
        measures={measures.entry_doors}
        onChange={updatedMeasures => onChange(
          { ...data, measures: { ...data.measures, entry_doors: updatedMeasures } },
        )}
      />
      <ArchesTransoms
        arches_transoms_measures={arches_transoms_measures}
        onChange={updatedArchesTransoms => onChange(
          { ...data, arches_transoms_measures: updatedArchesTransoms },
        )}
        openingCount={measures.entry_doors.length}
        openingTypeLabel="entry door"
      />
      <LaborMaterial
        labors_materials={labors_materials}
        onChange={updatedLaborsMaterials => onChange(
          { ...data, labors_materials: updatedLaborsMaterials },
        )}
      />
      <Comments
        comments={comments}
        onChange={updatedComments => onChange(
          { ...data, comments: updatedComments },
        )}
      />
      <ProjectNeeds
        needs={needs}
        onChange={updatedNeeds => onChange({ ...data, needs: updatedNeeds })}
        permitRequired={permitRequired}
        onPermitRequiredChange={onPermitRequiredChange}
      />
      <HomeDiagram
        home_diagram={home_diagram}
        onChange={updatedHomeDiagram => onChange(
          { ...data, home_diagram: updatedHomeDiagram },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
      <ProductTemplate
        product_template={product_template}
        onChange={updatedProductTemplate => onChange(
          { ...data, product_template: updatedProductTemplate },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
    </div>
  );
}

EntryDoorTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  permitRequired: PropTypes.bool,
  onPermitRequiredChange: PropTypes.func,
  onReadStart: PropTypes.func,
  onReadEnd: PropTypes.func,
};

export default EntryDoorTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/EntryDoorTemplate.jsx